export default "__VITE_ASSET__DDo3xybf__"